import { Categories } from 'emoji-picker-react';

export const emojiCategoryConfigs = [
  { category: Categories.SUGGESTED, name: 'よく使う絵文字' },
  { category: Categories.SMILEYS_PEOPLE, name: 'スマイリー＆人' },
  { category: Categories.ANIMALS_NATURE, name: '動物＆自然' },
  { category: Categories.FOOD_DRINK, name: 'フード＆ドリンク' },
  { category: Categories.TRAVEL_PLACES, name: 'トラベル＆場所' },
  { category: Categories.ACTIVITIES, name: 'アクティビティ' },
  { category: Categories.OBJECTS, name: 'オブジェクト' },
  { category: Categories.SYMBOLS, name: '記号' },
  { category: Categories.FLAGS, name: '旗' },
];
